@use 'styles/functions/rem' as *;

@keyframes indeterminate {
    0% {
        left: -30%;
        width: 30%;
    }

    100% {
        left: 100%;
        width: 30%;
    }
}

.loadingBar {
    background-color: var(--loading-bar-background-color);
    height: var(--loading-bar-height);
    overflow: hidden;
    position: relative;
    width: 100%;
}

.bar {
    background-color: var(--loading-bar-bar-color);
    border-radius: 0 rem(2px) rem(2px) 0;
    height: 100%;
    transition: width 0.3s ease;
}

.indeterminate {
    animation: indeterminate 1.5s ease-in-out infinite;
    position: absolute;
}
